import { connect } from 'react-redux'
import TabNav from './tab-nav'
import { getCounter } from '../../../../../stores/shared-presentations/shared-presentations.selectors'

const mapStateToProps = state => ({
  sharedCounter: getCounter(state)
})

export default connect(
  mapStateToProps,
  null
)(TabNav)
